import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import whatInput from "what-input";
import { useActiveColorScheme } from "@m/alchemy-theme";
import { DragDropIcon } from "../icons/DragDropIcon";
import { DragContent, DragHandle, DragListItem, DragWrapper, ReorderableList } from "../reorderable-list/ReorderableList.styled";
/* eslint-enable @m/magic/no-re-exports */
export const BeautifulList = Object.assign(ReorderableList, {
    DragListItem,
    DragWrapper,
    DragHandle,
    DragContent,
    reorder: (items, result) => {
        const { destination } = result;
        if (destination) {
            return reorder(items, result.source.index, destination.index);
        }
        return items;
    }
});
const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
export const BeautifulListItem = ({ draggableProvided, draggableStateSnapshot, children }) => {
    const isTouch = whatInput.ask() === "touch";
    const activeColorScheme = useActiveColorScheme();
    return (_jsx(DragListItem, { ref: draggableProvided.innerRef, ...draggableProvided.draggableProps, ...draggableProvided.dragHandleProps, activeColorScheme: activeColorScheme, hasChildren: false, role: "listitem", children: _jsxs(DragWrapper, { isBeautifulDragging: draggableStateSnapshot.isDragging, children: [_jsx(DragHandle, { "aria-hidden": "true", isDragging: draggableStateSnapshot.isDragging, isTouch: isTouch, children: _jsx(DragDropIcon, { "aria-hidden": "true" }) }), _jsx(DragContent, { children: children })] }) }));
};
export const useBeautifulList = ({ defaultCollection, reorder = BeautifulList.reorder }) => {
    const [items, setItems] = useState(defaultCollection);
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        setItems(reorder(items, result));
    };
    return { items, setItems, onDragEnd };
};
